module.exports = __webpack_public_path__ + "static/media/ecityclic_espublico-w.b79f175c.svg";